export interface WorkflowMessages {
  readonly clipboard: string;
  readonly help: string;
  readonly example: string;
  readonly cancel: string;
  readonly loading: string;
  readonly parsing: string;
  readonly cancelled: string;
  readonly clipboardFailed: string;
  readonly unreadable: string;
  readonly scanned: string;
  readonly noEvents: string;
  readonly headline: string;
  readonly blocked: string;
  readonly valid: string;
  readonly allDay: string;
  readonly dayMonth: string;
  readonly inheritedDate: string;
  readonly missingTitle: string;
}

export const EN_WORKFLOW: WorkflowMessages = {
  clipboard: 'Paste from clipboard',
  help: 'Paste text or an image here, or drop one file. Nothing is uploaded.',
  example: 'Try an example',
  cancel: 'Cancel',
  loading: 'Loading the local reader…',
  parsing: 'Finding events…',
  cancelled: 'Cancelled. Your input is still here.',
  clipboardFailed: 'Clipboard access is unavailable. Use Ctrl+V / ⌘V in the box, or choose a file.',
  unreadable: 'Could not read this file. Paste its text or choose another file.',
  scanned: 'This PDF contains scans. Attach a photo of a page instead, or paste the text.',
  noEvents: 'No events found. Try the example and replace its title, date and time.',
  headline: 'Your event list ({count})',
  blocked: 'Fix {count} invalid events before downloading all.',
  valid: 'Download only {count} valid events',
  allDay: 'No time stated; shown as all-day.',
  dayMonth: 'Read the numeric date as day/month. Please check.',
  inheritedDate: 'Date taken from the preceding line.',
  missingTitle: 'No title stated.',
};
